import {useQuery} from "@tanstack/react-query";
import {TaxInvoiceSearchParamType} from "../interface";
import {taxInvoiceListMapInit} from "../state";
import {readTaxList} from "../../../../api/order/TaxInvoiceApi";

type Props = {
    param: TaxInvoiceSearchParamType;
};

export const useReadTaxList = ({param}: Props) => {
    const {data} = useQuery({
        queryKey: ["readTaxList", param],
        queryFn: async () => await readTaxList(param),
        select: (res) => res?.data.result ?? taxInvoiceListMapInit,
    });

    return {data};
};
